<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button (click)="goBackOnce()">back</button>
        </div>
        <div class="container">
            <h1>Bus Tracking</h1>
        </div>
    </div>

    <!-- Develop this div appropriately -->
    <div class="container">
        <div class="tracking-banner">
            <figure>
                <a href="https://www.newgenapps.com/wp-content/uploads/2020/04/Navigator-Navigation-Google-Maps-Map-Location-Gps-2049643.jpg"
                    target="_blank">
                    <img id="t-img" alt="Tracking" src="assets/images/Navigator.jpg" width="304" height="328">
                </a>
            </figure>
        </div>
        <!-- <form > -->
        <form [formGroup]="dropDownForm" (ngSubmit)="goToPage('map')">
            <div>
                <label for="busInfo">Bus Id:  </label>
                <select formControlName="busInfo" class="form-control">
                    <option disabled>Choose Bus</option>
                    <option>Select Bus</option>
                    <option *ngFor="let Bus of Busdata">{{Bus.Bus_ID}}</option>
                </select><br><br><br>
                <!-- 
                <div *ngIf="validateFunction.busInfo.touched && validateFunction.busInfo.invalid">
                    <div *ngIf="validateFunction.busInfo.errors.required">Name is required.</div>
                </div> -->

            </div>
            <button type="submit" [disabled]="!dropDownForm.valid">Submit</button>
        </form>
    </div>
</div>